(function componentForm($, Adzuki)
{
	"use strict";

	var form = {
		name: 'TaskCommentAddEdit',
	};

	var form_id = 'taskcommentaddedit-';

	$(document).ready(function documentReady()
	{
		Adzuki.Form.registerForm(form);
	});

	form.load = function load()
	{
		// expanding/collapsing a comment
		$('#task-comments .comment-chevron').off().on('click', _showTaskComment);

		// editing a comment
		$('#task-comments .edit-comment-btn').off().on('click', _showEditCommentField);

		// cancel the edit of a comment
		$('#task-comments .cancel-edit-btn').off().on('click', _hideEditCommentField);

		// delete a comment
		$('#task-comments .delete-comment-btn').off().on('click', _deleteComment);
	};

	form.success = function success(response)
	{
		var task_id = $('#' + form_id + 'task_id').val();

		if (Adzuki.Form.hasError(response)) {
			return false;
		}

		// show success message and re-render the form in the modal on success
		Adzuki.StatusMessage('success', 'The comment has been saved.', 'Success', {
			onClose: function onAlertClosed() {
				_renderTaskCommentsView(task_id);
			}
		});
	};

	function _deleteComment(e)
	{
		var $btn_elem  = $(this);
		var comment_id = $btn_elem.data('comment-id');
		var task_id    = $('#' + form_id + 'task_id').val();

		e.preventDefault();

		Adzuki.CustomConfirm({
			body   : 'Are you sure you wish to delete this comment?',
			confirm: function confirmDeletion() {
				var delete_url = '/Tasks/deleteComment/' + task_id + '/' + comment_id;

				Adzuki.Ajax.get(delete_url)
					.then(function taskCommentDeleted(response) {
						Adzuki.StatusMessage('success', 'The comment has been deleted.', 'Success');
						_renderTaskCommentsView(task_id);
					});
			},
		});
	}

	function _hideEditCommentField(e)
	{
		var $btn_elem  = $(this);
		var comment_id = $btn_elem.data('comment-id');

		e.preventDefault();

		$('.comment-' + comment_id + ' .comment-actions').removeClass('hidden');
		$('.comment-' + comment_id + ' .comment-text').removeClass('hidden');
		$('.comment-' + comment_id + ' .comment-edit-field').addClass('hidden');
	}

	function _showEditCommentField(e)
	{
		var $btn_elem  = $(this);
		var comment_id = $btn_elem.data('comment-id');

		e.preventDefault();

		$('.comment-' + comment_id + ' .comment-actions').addClass('hidden');
		$('.comment-' + comment_id + ' .comment-text').addClass('hidden');
		$('.comment-' + comment_id + ' .comment-edit-field').removeClass('hidden');
	}

	function _showTaskComment(e)
	{
		var $chev_elem = $(this);
		var comment_id = $chev_elem.data('comment-id');

		e.preventDefault();

		if (comment_id && $('#collapsed_' + comment_id).length > 0) {
			$chev_elem.addClass('hidden');

			if ($chev_elem.hasClass('right')) {
				// show the whole comment
				$('.comment-' + comment_id + ' .chevron .down').removeClass('hidden');
				$('#expanded_' + comment_id).removeClass('hidden');
				$('#collapsed_' + comment_id).addClass('hidden');
			} else if ($chev_elem.hasClass('down')) {
				// hide the full comment
				$('.comment-' + comment_id + ' .chevron .right').removeClass('hidden');
				$('#expanded_' + comment_id).addClass('hidden');
				$('#collapsed_' + comment_id).removeClass('hidden');
			}
		}
	}

	function _renderTaskCommentsView(task_id)
	{
		var $modal = $('.modal');

		// render comments view
		Adzuki.Ajax.get('/Tasks/viewTaskComments/' + task_id)
			.then(function viewTaskComments(response) {
				$modal.find('#task-comments').html(response);

				Adzuki.Form.initAjaxForm('TaskCommentAddEdit');
			});

		// update the amount of comments
		Adzuki.Ajax.get('/Tasks/getCommentsCount/' + task_id)
			.then(function getCommentsCount(response) {
				$('.task-comments-count').addClass('hidden');

				if (response && response.comments_count > 0) {
					$('.task-comments-count')
					.removeClass('hidden')
					.text(response.comments_count);
				}
			});
	}
}(jQuery, window.Adzuki || {}));
